export default __webpack_public_path__ + "de52d14541bb692fda6004effa3f3369.png";